import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=05f12c6a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=05f12c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f12c6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f12c6a')) {
      api.createRecord('05f12c6a', component.options)
    } else {
      api.reload('05f12c6a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=05f12c6a&scoped=true&", function () {
      api.rerender('05f12c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F49R00KfE3Gz/JS/comp/SearchFilterTokens.vue"
export default component.exports